require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-how-to-choose-a-stack-part-4-asp-dot-net.json") })
        }
      }, "path---blog-how-to-choose-a-stack-part-4-asp-dot-net");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-how-to-choose-a-stack-part-4-asp-dot-net!./.cache/json/blog-how-to-choose-a-stack-part-4-asp-dot-net.json
// module id = 847
// module chunks = 231608221292675